/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {CodeFilterComponent} from './code-filter.component';
import {PipesModule} from '../../pipes/pipes.module';
import {TooltipModule} from '../../tooltip/tooltip.module';
import {FilterFooterModule} from '../filter-footer/filter-footer.module';
import {InputModule} from '../../input/input.module';
import {LoadingSpinnerModule} from '../../loading/loading-spinner/loading-spinner.module';

@NgModule({
    declarations: [CodeFilterComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        PipesModule,
        TooltipModule,
        FilterFooterModule,
        InputModule,
        LoadingSpinnerModule
    ],
    exports: [CodeFilterComponent]
})
export class CodeFilterModule {

}
